import Phaser from 'phaser'
import { TrafficWindow } from '../../../modeles/lines'
import { UserPreferences } from '../../../../app/core/configurations/user/user.preferences'
import { LiveEventElement } from './live-event-element'

export class LiveEventElementFactory {
  public static buildLiveElement({
    scene,
    trafficWindow,
    positionYOfPlatformDisplay,
    userPreferences,
    showStationText,
    newLineMappingConstructionMethod,
  }: {
    scene: Phaser.Scene
    trafficWindow: TrafficWindow
    positionYOfPlatformDisplay: number
    userPreferences: UserPreferences
    showStationText: boolean
    newLineMappingConstructionMethod: boolean
  }): LiveEventElement | null {
    return trafficWindow?.platFormName // we build only element for platform
      ? new LiveEventElement({
          scene,
          trafficWindow,
          positionYOfPlatformDisplay,
          userPreferences,
          showStationText,
          newLineMappingConstructionMethod,
        })
      : null
  }
}
